import React from 'react';
import style from './style.module.scss';
import { useFetch } from '@/hooks';
import { MiniTitle } from '@/ui/miniTitle/miniTitle';
import Image from 'next/image';
import Link from 'next/link';

import { MarqueeItems } from '../marquee-items/marquee-items';
export const Partners = async () => {
  const { data } = await useFetch(process.env.NEXT_PUBLIC_API_URL + '/poleznye-ssylkis?populate=*');

  if (!data) {
    return <p>Произошла ошибка...</p>;
  }

  return (
    <div className={style.links}>
      <div className={style.top}>
        <MiniTitle text="Партнёры" />
      </div>
      <MarqueeItems data={data} />
    </div>
  );
};
